module.exports = __webpack_public_path__ + "static/media/excel_icon_black.e6805c7b.png";